module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_c('a', {
    attrs: {
      "id": "HLD1"
    }
  }), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "dtxt"
  }, [_c('i', [_vm._v("For my dedicated husband, Bruce, who never once thought that writing a book was a crazy idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "dtxt"
  }, [_c('i', [_vm._v("Also, to our children, Kelsey, Karly, and Tessa, who have been as excited as I am about this project.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5b64a78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_chapter01.vue
// module id = 63
// module chunks = 0